import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
    selector: 'app-call-back',
    templateUrl: './call-back.component.html',
    styleUrls: ['./call-back.component.css'],
    standalone: false
})
export class CallBackComponent implements OnInit {

  constructor(private route: ActivatedRoute,
              private router: Router) {
  }


  ngOnInit(): void {
    console.log('callback');
    const registrationId =  this.route.snapshot.params['registrationId'];

      const token = this.route.snapshot.queryParamMap.get('token');
      const userId = this.route.snapshot.queryParamMap.get('userId');
      console.log('token', token);
      console.log('currentUser', userId);

      if (token && userId) {
        console.log('token', token);
        localStorage.setItem('token', token);
        localStorage.setItem('currentUser', userId);
        this.router.navigateByUrl('/dashboard/resources')
      }

  }

}
